import React from 'react';

const termsAndConditionConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/terms-and-condition',
			component: React.lazy(() => import('./terms-and-condition'))
		},
	]
};

export default termsAndConditionConfig;